import React from 'react';
import './NumericKeypad.css';

const NumericKeypad = ({ value, onChange, onSubmit, maxLength = 10 }) => {
  const handleNumberClick = (num) => {
    if (value.length >= maxLength) return;
    onChange(value + num);
  };

  const handleDecimalPoint = () => {
    if (value.includes('.')) return; // Prevent multiple decimal points
    if (value === '') {
      onChange('0.');
    } else {
      onChange(value + '.');
    }
  };

  const handleBackspace = () => {
    onChange(value.slice(0, -1));
  };

  const handleClear = () => {
    onChange('');
  };

  const handleSubmit = () => {
    // Ensure we don't submit with a trailing decimal point
    if (value.endsWith('.')) {
      onChange(value + '0');
    }
    onSubmit();
  };

  return (
    <div className="numeric-keypad">
      <div className="keypad-display">
        <input 
          type="text" 
          value={value} 
          readOnly 
          className={value.length > 8 ? 'small-text' : ''}
        />
      </div>
      <div className="keypad-grid">
        <button onClick={() => handleNumberClick('7')}>7</button>
        <button onClick={() => handleNumberClick('8')}>8</button>
        <button onClick={() => handleNumberClick('9')}>9</button>
        <button onClick={handleBackspace}>←</button>
        
        <button onClick={() => handleNumberClick('4')}>4</button>
        <button onClick={() => handleNumberClick('5')}>5</button>
        <button onClick={() => handleNumberClick('6')}>6</button>
        <button onClick={handleClear}>C</button>
        
        <button onClick={() => handleNumberClick('1')}>1</button>
        <button onClick={() => handleNumberClick('2')}>2</button>
        <button onClick={() => handleNumberClick('3')}>3</button>
        <button onClick={handleDecimalPoint}>.</button>
        
        <button onClick={() => handleNumberClick('0')}>0</button>
        <button className="submit-btn" onClick={handleSubmit} style={{ gridColumn: 'span 3' }}>✓</button>
      </div>
    </div>
  );
};

export default NumericKeypad;
